import {Injectable} from '@angular/core';
import {C4AParams, C4AParamsAttr} from "../model/params";

@Injectable({
    providedIn: 'root'
})
export class ParametersService {

    params: C4AParams;

    constructor() {
        this.params = new C4AParams();
    }

    reset() {
        this.params = new C4AParams();
    }

    getParams(): C4AParams {
        return this.params;
    }
}
